import request from '../request'

/**
 * 猜你想问列表
 */
export function fetchGuessQsList () {
  return request({
    url: '/app/customer/question/get/list',
    method: 'get'
  })
}

/**
 * 获取投诉、意见标签
 */
export function fetchComplaintTags (params) {
  return request({
    url: '/app/customer/label/list',
    method: 'get',
    params
  })
}

/**
 * 获取问题列表
 * @param { object } params 参数
 */
export function fetchQsList (params) {
  return request({
    url: '/app/customer/question/get/list/code',
    method: 'get',
    params
  })
}

/**
 * 获取问题详情
 */
export function fetchDetail (params) {
  return request({
    url: '/app/customer/question/get/one',
    method: 'get',
    params
  })
}

/**
 * 提交问题投诉
 */
export function submitComplaint (data) {
  return request({
    url: '/app/customer/question/order/save',
    method: 'post',
    data
  })
}

/**
 * 获取进度列表
 */
export function fetchComplaintList (data, loading) {
  return request({
    url: '/app/customer/order/page/list',
    method: 'post',
    loading,
    data
  })
}

/**
 * 获取工单记录
 */
export function fetchWorkOrder (params) {
  return request({
    url: '/app/customer/get/list',
    method: 'get',
    params
  })
}

/**
 * 工单申诉
 *
 */
export function recordAdd (data) {
  return request({
    url: '/app/customer/record/save',
    method: 'post',
    data
  })
}

/**
 * 发起追责
 *
 */
export function confirmDuty (data) {
  return request({
    url: '/app/order/sideDuty',
    method: 'post',
    data
  })
}

/**
 * 点赞或反对问题
 */
export function evaluateQs (data) {
  return request({
    url: '/app/customer/add/like',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}

export function uploadFile (file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/app/customer/question/upload ',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}
